define('OutSystems/ReactWidgets/RadioGroup',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "./AbstractButtonGroup"], function (require, exports, tslib_1, Widget_1, AbstractButtonGroup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RadioGroup = void 0;
    var RadioGroup = (function (_super) {
        tslib_1.__extends(RadioGroup, _super);
        function RadioGroup() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        RadioGroup.prototype.getAdditionalPropsToChild = function () {
            return { groupName: this.getId() };
        };
        RadioGroup.prototype.getDataAttribute = function () {
            return "data-radio-group";
        };
        RadioGroup = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], RadioGroup);
        return RadioGroup;
    }(AbstractButtonGroup_1.AbstractButtonGroup));
    exports.RadioGroup = RadioGroup;
});
//# sourceMappingURL=RadioGroup.js.map;
